package br.com.htms.inspeccaocampo.util

/** Senha única do menu Configuração e do Modo treinamento. */
object AdminSenha {
    const val VALOR = "3265"

    fun validar(senha: String): Boolean = senha.trim() == VALOR
}
